import { triggerHaptic } from "@/lib/nativeHaptics";
import { trackEvent } from "@/lib/analytics";
import { shortHandle } from "@/lib/guestHandle";

interface SavedEmptyGuestProps {
  onSignup: () => void;
  guestHandle?: string | null;
}

export function SavedEmptyGuest({ onSignup, guestHandle }: SavedEmptyGuestProps) {
  return (
    <div
      style={{
        background: "#FFFCF8",
        border: "0.5px solid #E8E2D9",
        borderRadius: 20,
        padding: "36px 20px",
        marginTop: 60,
        textAlign: "center",
      }}
    >
      <i
        className="ti ti-bookmark"
        style={{ fontSize: 36, color: "#C84B2F" }}
        aria-hidden="true"
      />
      <p
        className="l2f-type-section-header"
        style={{ marginTop: 10, color: "#C84B2F" }}
      >
        START YOUR COLLECTION
      </p>
      {guestHandle && (
        <p
          style={{
            marginTop: 4,
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontStyle: "italic",
            fontSize: 12,
            color: "#C84B2F",
          }}
        >
          {shortHandle(guestHandle)}
        </p>
      )}
      <h2
        className="l2f-type-h2"
        style={{ marginTop: 6, color: "#2C2820" }}
      >
        Save your favourite looks
      </h2>
      <p
        className="l2f-type-secondary"
        style={{ marginTop: 8, color: "#6B6560" }}
      >
        Sign up to bookmark outfits and build your personal look book.
      </p>
      <button
        type="button"
        onClick={() => {
          void triggerHaptic("primary-action");
          trackEvent("saved_empty_cta_tapped", { variant: "guest_signup" });
          onSignup();
        }}
        style={{
          marginTop: 16,
          background: "#C84B2F",
          color: "#fff",
          border: "none",
          borderRadius: 22,
          padding: "10px 22px",
          minHeight: 44,
          fontSize: 15,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Sign up free
      </button>
    </div>
  );
}
